import {
    CheckoutActionTypes,
    CheckoutContextValue,
    CheckoutRoute,
    isQuickCheckoutFlow,
    PlaceOrderData,
} from "@swiggy-private/checkout-core";

import { EXPERIMENTS_VALUES } from "@payment-client/constants/Experiments";

/**
 * QC turbo place order expands the webview before the API returns; `html.quick-checkout`
 * is cleared on status 0 and restored on error, only when the trigger was the compact
 * QUICK_CHECKOUT route (not MRO full cart in the same AIP session).
 */
export const shouldUpdateQuickCheckoutBackgroundForTurboPlaceOrder = (
    placeOrderData: PlaceOrderData | undefined,
    activeRouteName: string,
): boolean =>
    isQuickCheckoutFlow() &&
    placeOrderData?.extraArbitaryData?.isTurboPaymentMethod === true &&
    activeRouteName === CheckoutRoute.QUICK_CHECKOUT;

export const handlePaymentFailure = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    err: any,
    placeOrderData: PlaceOrderData,
    setCheckoutState: CheckoutContextValue["setCheckoutState"],
): void => {
    const paymentFailureResponse = err?.data?.paymentFailureResponse;
    const isFallbackApiEnabled = err?.data?.xpData?.showPaymentFailureReasonHalfCard === "true";
    const autopayPaymentFailure = [
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.CONSENT,
        EXPERIMENTS_VALUES.AUTOPAY_PHASE_2.SUBTLE_AUTOPLACE,
    ].includes(err?.data?.xpData?.autoPayVariant);

    if (autopayPaymentFailure) {
        setCheckoutState({
            type: CheckoutActionTypes.AUTOPAY_ELIGIBLE_PAYMENT_FAILED,
            payload: {
                paymentFailureResponse,
                placeOrderData,
                isFallbackApiEnabled: isFallbackApiEnabled,
                autoPayPaymentFailureVariant: err?.data?.xpData?.autoPayVariant,
            },
        });
    } else {
        setCheckoutState({
            type: CheckoutActionTypes.PAYMENT_FAILED,
            payload: {
                paymentFailureResponse,
                placeOrderData,
                isFallbackApiEnabled: isFallbackApiEnabled,
            },
        });
    }
};
